export const TEXT_ROWS_MIN = 3;
export const TEXT_ROWS_MAX = 5;

export function fittedTextRows(overflows: (rows: number) => boolean): number {
  let rows = TEXT_ROWS_MIN;
  while (rows < TEXT_ROWS_MAX && overflows(rows)) rows += 1;
  return rows;
}
